import en from './en.json'
import nl from './nl.json'

export const translations = {
    'en': en,
    'nl': nl
}

export const table_translations = [
    [/Relatie met andere studieonderdelen/gi, "Associated courses"],
    [/Werkcoll\..?\/.?instructiecollege/gi, "Tutorial"],
    [/Relatie met beroepspraktijk/gi, "Professional context"],
    [/Ondergrens bij compensatie/gi, "Minimum mark to qualify for compensation"],
    [/Paper.?\/.?verslag.?\/.?scriptie/gi, "Paper / Report / Thesis"],
    [/Leerdoelen.?\/.?competenties/gi, "Learning objectives / Competencies"],
    [/Studieloopbaanbegeleiding/gi, "Study counselling"],
    [/Begeleiding.?\/.?consultancy/gi, "Guidance / Consultancy"],
    [/Leerdoelen\/competenties/gi, "Learning objectives / Competencies"],
    [/Supervisie.?\/.?reflectie/gi, "Supervision / Reflection"],
    [/Taal van het onderwijs/gi, "Language of instruction"],
    [/Toelichting werkvormen/gi, "Additional notes"],
    [/Voldaan of Onvoldoende/gi, "Pass/Fail"],
    [/Cijfer met 1 decimaal/gi, "Mark to one decimal place"],
    [/Portfolioproducten/gi, "Portfolio products"],
    [/Toets schriftelijk/gi, "Test (written)"],
    [/Studiepunten in EC/gi, "Credits (EC, European Credits)"],
    [/Omschrijving SIS/gi, "Course name in SIS"],
    [/Beoordelingsmaat/gi, "Assessment measure"],
    [/Stage.?\/.?praktijk/gi, "Internship"],
    [/Studiegidsnummer/gi, "Catalogue number"],
    [/Geen ondergrens/gi, "No minimum mark"],
    [/Zelfstudie-uren/gi, "Independent study hours"],
    [/Zelfstudieuren/gi, "Independent study hours"],
    [/Studiegids&shy;nummer/gi, "Course catalogue number"],
    [/Studiegidsnummer/gi, "Course catalogue number"],
    [/Studiemateriaal/gi, "Course materials"],
    [/Toets mondeling/gi, "Test (oral)"],
    [/Tijd en plaats/gi, "Schedule and location"],
    [/Toets praktijk/gi, "Test (practical)"],
    [/Toets digitaal/gi, "Test (digital)"],
    [/Geheel cijfer/gi, "Rounded mark"],
    [/Aanwezigheid/gi, "Attendance"],
    [/Beschrijving/gi, "Description"],
    [/Ingangseisen/gi, "Entry requirements"],
    [/Presentatie/gi, "Presentation"],
    [/Compensatie/gi, "Compensation"],
    [/Toetsvormen/gi, "Assessment methods"],
    [/Collegejaar/gi, "Academic year"],
    [/Contacttijd/gi, "Contact time"],
    [/Coördinator/gi, "Course coordinator"],
    [/Contacturen/gi, "Contact hours"],
    [/Hoorcollege/gi, "Lecture"],
    [/Werkvormen/gi, "Teaching methods"],
    [/Assessment/gi, "Assessment"],
    [/Beg\.\/cons\./gi, "Guid/cons."],
    [/Studiejaar/gi, "Academic year"],
    [/Docent(en)/gi, "Lecturer(s)"],
    [/Toets schr/gi, "Test writ."],
    [/Supervisie/gi, "Supervisn."],
    [/Studlb\.beg/gi, "Counsel."],
    [/Presentat\./gi, "Presentat."],
    [/Toets prak/gi, "Test pract"],
    [/Toets mond/gi, "Test oral"],
    [/Studlb\.beg/gi, "Counsel."],
    [/Toets digi/gi, "Test digi."],
    [/Werkcoll\./gi, "Tutorial"],
    [/Practicum/gi, "PracticLab"],
    [/Opleiding/gi, "Programme"],
    [/Toetsvorm/gi, "Type"],
    [/Portfolio/gi, "Portfolio"],
    [/Presentie/gi, "Attendance"],
    [/Werkcoll\./gi, "Tutorial"],
    [/Practicum/gi, "PracticLab"],
    [/Leerlijn/gi, "Learning track"],
    [/Training/gi, "Training"],
    [/Opdracht/gi, "Assignment"],
    [/Excursie/gi, "Excursion"],
    [/Periode/gi, "Period"],
    [/College/gi, "Lecture"],
    [/Product/gi, "Product"],
    [/Project/gi, "Project"],
    [/Weging/gi, "%"],
    [/Paper/gi, "Paper"],
    [/Stage/gi, "Internship"],
    [/Afnamevorm/gi, "Administration Form"],
    [/Naam/gi, "Name"],
    [/\bNee\b/gi, "No"],
    [/\bJa\b/gi, "Yes"],
    [/\bNr\b/gi, "No"],
    [/Digitaal/gi, "Digital"],
    [/Uploaden/gi, "Upload"],
    [/Mondeling/gi, "Oral"],
    [/Kennistoets/gi, "Knowledge assessment"],
    [/Beroepsproduct/gi, "Professional product"],
    [/Gedragsassessment/gi, "Behavioural assessment"],
    [/Portfolio-assessment/gi, "Portfolio assessment"],
    [/Portfolioassessment/gi, "Portfolio assessment"],
    [/Cursus/gi, "Course"],
    [/Gastcollege/gi, "Guest lecture"],
    [/Formatieve evaluatie/gi, "Formative evaluation"],
    [/Individuele begeleiding/gi, "Individual supervision"],
    [/Responsiecollege/gi, "Response Lecture"],
    [/Werk-\/instructiecollege /gi, "Tutorial"],
    [/Werk\/instructiecollege /gi, "Tutorial"],
    [/Werk-\/instructiecollege/gi, "Tutorial"],
    [/Werk\/instructiecollege/gi, "Tutorial"],
    [/Werkgroep /gi, "Tutorial group"],
    [/Werkgroep/gi, "Tutorial group"],
    [/Zelfstandig werken \/ huiswerk/gi, "Self study / prepatory work"],
    [/Pen-en-Papier/gi, "Pen-and-Paper"],
    [/PenenPapier/gi, "Pen-and-Paper"],
    [/VOG/gi, "Mark in words"]
];